"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OtherSourceProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
class OtherSourceProvider {
  constructor() {
    (0, _defineProperty2.default)(this, "name", "other");
  }
  getValue(provider, source) {
    if (source.name === "sender") {
      return {
        annotation() {
          return '<span class="user-address">Your Wallet Address</span>';
        },
        value() {
          return provider.getAccount();
        }
      };
    }
  }
}
exports.OtherSourceProvider = OtherSourceProvider;
//# sourceMappingURL=OtherSourceProvider.js.map